import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Paper, Box, CircularProgress } from "@mui/material";
import { TypographyLarge } from "../../../../components/customComponent";
import { getDisruptionAnnouncement } from "../../../store/actions/smrt/disruptionAction";
import { red } from "@mui/material/colors";
import LinkAnnouncement from "./LinkAnnouncement";
import DeactivateDisruption from "./DeactivateDisruption";
import ActivateDisruption from "./ActivateDisruption";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { MdArrowOutward } from "react-icons/md";

const BroadCastStatus = () => {
  const { t } = useTranslation("smrtDisruption");
  const dispatch = useDispatch();

  const { disruptionAnnouncement, loadingDisruption: loading } = useSelector(
    (state) => state.smrtDisruption,
  );

  useEffect(() => {
    dispatch(getDisruptionAnnouncement());
  }, [dispatch]);

  if (loading)
    return (
      <Paper
        elevation={2}
        sx={{
          p: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress size={20} thickness={3} sx={{ color: "#1D4ED8" }} />
      </Paper>
    );

  return Object.keys(disruptionAnnouncement).length === 0 ? (
    <Paper
      elevation={2}
      sx={{
        p: 2,
      }}
    >
      <Box sx={{ display: "flex", flexWrap: "nowrap", alignItems: "center" }}>
        <LinkAnnouncement announcementStatus={"UNLINKED"} />
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            justifyContent: "center",
          }}
        >
          <TypographyLarge
            sx={{
              fontWeight: 600,
              color: red[600],
              textTransform: "capitalize",
            }}
          >
            {t("link.noLinkedAnnouncementLabel")}
          </TypographyLarge>
        </Box>
      </Box>
    </Paper>
  ) : (
    <Paper
      elevation={2}
      sx={{
        p: 2,
        mb: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
      }}
    >
      <LinkAnnouncement
        announcementStatus={"LINKED"}
        disruptionStatus={disruptionAnnouncement.status}
      />

      <TypographyLarge sx={{ fontWeight: 600, mx: 2 }}>
        {t("link.idLabel") + " " + disruptionAnnouncement.id}
      </TypographyLarge>

      <Link
        to={"/announcement/detail/" + disruptionAnnouncement.id}
        style={{ textDecoration: "none" }}
      >
        <TypographyLarge
          sx={{
            fontWeight: 600,
            textTransform: "capitalize",
            my: 2,
            mr: 2,
            cursor: "pointer",
            color: "primary.main",
            "&:hover": {
              textDecoration: "underline",
              color: "primary.dark",
            },
          }}
        >
          {t("link.announcementNameLabel") + " " + disruptionAnnouncement.name}
          <MdArrowOutward size={18} />
        </TypographyLarge>
      </Link>

      {disruptionAnnouncement.isActive ? (
        <DeactivateDisruption announcement={disruptionAnnouncement} />
      ) : (
        <ActivateDisruption announcement={disruptionAnnouncement} />
      )}
    </Paper>
  );
};

export default BroadCastStatus;
